import React from 'react'
import { useStyles } from './styles'
import { Chart } from '@devexpress/dx-react-chart-material-ui'

const BAR_COLORS = ['#4B8DEA', '#20B3C7', '#EA882D', '#8520C7']

const Bar = ({ arg, barWidth, maxBarWidth, val, startVal, style, index, value }) => {
  const height = maxBarWidth * barWidth
  const classes = useStyles()

  return (
    <React.Fragment>
      {value === 0 ? null : (
        <rect
          x={startVal}
          y={arg - height / 2}
          width={val}
          height={height}
          fill={BAR_COLORS[index - 1]}
          visibility='visible'
          style={style}
        />
      )}
      <Chart.Label
        x={value === 0 ? 21 : val + 21}
        y={arg}
        dominantBaseline='middle'
        textAnchor={value === 0 ? 'left' : 'middle'}
        style={
          value === 0
            ? {
                fill: '#8688A1',
                fontFamily: 'National',
                fontSize: '13px'
              }
            : {
                fill: '#000000',
                fontFamily: 'National',
                fontSize: '18px',
                fontWeight: 500
              }
        }
        className={classes.label}
      >
        {value === 0 ? 'No Learner Engagement' : Math.round((value + Number.EPSILON) * 100) / 100}
      </Chart.Label>
    </React.Fragment>
  )
}

export default Bar
